// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q_IobN6wMUVRU2QIH3CX {
    width: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    /* background: rgba(var()); */
    border-radius: 24px;
    border: 1px solid rgba(65, 69, 79, 0.2);
    background: rgba(var(--secondary-bg), 0.4);
    backdrop-filter: blur(40px);
    -webkit-backdrop-filter: blur(40px); 
    margin-bottom: 12px;
    margin-top: 12px;
}

.OaN0ZlStpJ8_Q28Pd9qx {
    font-size: 16px;
    font-style: normal;
    font-weight: 510;
    line-height: 20px;
    letter-spacing: -0.5px;
    color: rgb(var(--placeholder-primary));
}

.mNFQQsR6hplJACkwI2By {
    color: rgb(var(--accent-warning));
}

.DA240M2PuDXS038O4iNl {
    color: rgb(var(--accent-error));
}

.of6P699ndWUkpQUQcDR9 {
    background: rgba(56, 68, 82, 1);
    width: 100%;
    height: 1.2px;
}

/* .exitBtn {
    border: none;
    box-shadow: none;
    background: transparent;
    cursor: pointer;
    padding: 19px 0px 19px 0px;
    border-radius: 24px;
    width: 100%;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.exitBtn:active {
    background: rgba(var(--placeholder-tertiary), 0.2);
  } */

  .DK_dwW6epmaNw3uesOPg {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  .zDtOu1pZ4CSrwqzSFQmc {
    font-size: 14px;
    font-weight: 410;
  }
  
  .vmtiSQYBljm9FgjSBGb_ {
    margin-top: 12px;
    font-size: 15px;
    font-weight: 540;
    padding: 14px;
    border-radius: 12px;
    min-width: 250px;
    background: rgba(var(--placeholder-primary), 0.10);
    border: none;
    box-shadow: none;
    color: rgb(var(--placeholder-primary));
    cursor: pointer;
    transition: background 0.3s ease 0s;
  }
  
  .vmtiSQYBljm9FgjSBGb_:active {
    background: rgba(var(--placeholder-primary), 0.20);
  } 

.H6dCKziQ7rS6KOJz_DzD {
    font-size: 32px;
    font-style: normal;
    font-weight: 510;
    line-height: 32px; /* 100% */
    letter-spacing: -0.264px;
    color: rgb(var(--placeholder-primary));
    text-align: center;

    margin-top: 32px;
    margin-bottom: 32px;
}`, "",{"version":3,"sources":["webpack://./src/pages/pswchange/pswchange.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,6BAA6B;IAC7B,mBAAmB;IACnB,uCAAuC;IACvC,0CAA0C;IAC1C,2BAA2B;IAC3B,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,aAAa;AACjB;;AAEA;;;;;;;;;;;;;;;;;KAiBK;;EAEH;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kDAAkD;IAClD,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,eAAe;IACf,mCAAmC;EACrC;;EAEA;IACE,kDAAkD;EACpD;;AAEF;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,wBAAwB;IACxB,sCAAsC;IACtC,kBAAkB;;IAElB,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".infoWrapper {\n    width: 100%;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    /* background: rgba(var()); */\n    border-radius: 24px;\n    border: 1px solid rgba(65, 69, 79, 0.2);\n    background: rgba(var(--secondary-bg), 0.4);\n    backdrop-filter: blur(40px);\n    -webkit-backdrop-filter: blur(40px); \n    margin-bottom: 12px;\n    margin-top: 12px;\n}\n\n.infoText {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 510;\n    line-height: 20px;\n    letter-spacing: -0.5px;\n    color: rgb(var(--placeholder-primary));\n}\n\n.warning {\n    color: rgb(var(--accent-warning));\n}\n\n.error {\n    color: rgb(var(--accent-error));\n}\n\n.line {\n    background: rgba(56, 68, 82, 1);\n    width: 100%;\n    height: 1.2px;\n}\n\n/* .exitBtn {\n    border: none;\n    box-shadow: none;\n    background: transparent;\n    cursor: pointer;\n    padding: 19px 0px 19px 0px;\n    border-radius: 24px;\n    width: 100%;\n    text-align: left;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.exitBtn:active {\n    background: rgba(var(--placeholder-tertiary), 0.2);\n  } */\n\n  .deployPanelInner {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  \n  .errorText {\n    font-size: 14px;\n    font-weight: 410;\n  }\n  \n  .deployBtn {\n    margin-top: 12px;\n    font-size: 15px;\n    font-weight: 540;\n    padding: 14px;\n    border-radius: 12px;\n    min-width: 250px;\n    background: rgba(var(--placeholder-primary), 0.10);\n    border: none;\n    box-shadow: none;\n    color: rgb(var(--placeholder-primary));\n    cursor: pointer;\n    transition: background 0.3s ease 0s;\n  }\n  \n  .deployBtn:active {\n    background: rgba(var(--placeholder-primary), 0.20);\n  } \n\n.title {\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 510;\n    line-height: 32px; /* 100% */\n    letter-spacing: -0.264px;\n    color: rgb(var(--placeholder-primary));\n    text-align: center;\n\n    margin-top: 32px;\n    margin-bottom: 32px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoWrapper": `Q_IobN6wMUVRU2QIH3CX`,
	"infoText": `OaN0ZlStpJ8_Q28Pd9qx`,
	"warning": `mNFQQsR6hplJACkwI2By`,
	"error": `DA240M2PuDXS038O4iNl`,
	"line": `of6P699ndWUkpQUQcDR9`,
	"deployPanelInner": `DK_dwW6epmaNw3uesOPg`,
	"errorText": `zDtOu1pZ4CSrwqzSFQmc`,
	"deployBtn": `vmtiSQYBljm9FgjSBGb_`,
	"title": `H6dCKziQ7rS6KOJz_DzD`
};
export default ___CSS_LOADER_EXPORT___;
